import { EKwikUIInputPasswordSize } from "./input-password.definitions";

export const DEFAULT_VALUES = {
  disabled: false,
  focus: false,
  formControlName: "form_control_input_password",
  hintContent: "",
  icon: "",
  id: "input_password",
  invalid: false,
  label: "Input Password",
  placeholder: "Please enter password",
  postfix: "",
  prefix: "",
  size: EKwikUIInputPasswordSize.L
};

export const VALIDATE_KEY_VALUES = {
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  label: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  size: true
};
